import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

/** Escritura directa a Firestore: debe funcionar offline (ver plan §2). */
export async function marcarAsistencia(
  eventoId: string,
  token: string,
  quien: 'titular' | 'acompanante',
  presente: boolean,
  uid: string | null,
) {
  await updateDoc(doc(db, 'eventos', eventoId, 'invitaciones', token), {
    [`asistencia.${quien}.presente`]: presente,
    [`asistencia.${quien}.hora`]: presente ? new Date().toISOString() : null,
    [`asistencia.${quien}.porQuien`]: presente ? uid : null,
  });
}
